import { createWebHistory, createRouter } from 'vue-router'
import myRoutes from './my_routes.js'
import { beforeEach, afterEach } from './guard.js'


const myCreateRouter = () =>
  new createRouter({
    history: createWebHistory(), // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: myRoutes
  })

const router = myCreateRouter()

router.beforeEach(beforeEach)
router.afterEach(afterEach)


export default router
